"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Product_module_1 = require("./modules/Product.module");
const GiftVoucher_module_1 = require("./modules/GiftVoucher.module");
const loadGiftVoucherModule = (initialData) => ({
    hasRouter: false,
    modules: [(0, Product_module_1.default)(initialData), (0, GiftVoucher_module_1.default)()],
});
exports.default = loadGiftVoucherModule;
